var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-img-list"},_vm._l((_vm.items),function(item,index){return _c('figure',{key:index},[_c('img',{staticClass:"preview-img-item",attrs:{"src":item.preview},on:{"click":function($event){return _vm.$photoswipe.open(index, _vm.items)}}}),_vm._v(" "),_c('figcaption',[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }